import { GetterTree } from 'vuex';
import { MessagesState } from './types';

const getters: GetterTree<MessagesState, any> = {
  displayMessages: (state: MessagesState) => {
    return state.selectedOtherUser?.showMessageHistory === false ? [] : state.messages;
  },
  showComposer: (state: MessagesState) => {
    return !state.selectedOtherUser?.showTrustSafetyBanner;
  },
  headerTitle: (state: MessagesState) => {
    return state.selectedOtherUser?.name || (state.currentChannelUrl ? 'Conversation' : 'Messages');
  },
  headerAvatarName: (state: MessagesState) => state.selectedOtherUser?.name || '',
  headerAvatarUrl: (state: MessagesState) => state.selectedOtherUser?.image || '',
};

export default getters;
